import React, { useEffect, useState } from 'react';
import { useDarkMode } from "../contexts/darkModeContext";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/firebase";
import { useAuth } from "../contexts/authContext";
import OrderSection from "./Orders/OrderSection";
import Loading from "./Widgets/Loading";
import OrderSearchInput from "./Orders/OrderSearchInput";
import {Button, Select} from "@headlessui/react";
import NewOrder from "./OrderForm/NewOrder";
import {numberWithCommas} from "./GLOBAL/GlobalFunctions";
import {ChevronDownIcon} from "@heroicons/react/16/solid";
import {ArrowPathIcon} from "@heroicons/react/24/outline";
import ActionPillButton from "./Widgets/ActionPillButton";

const Archive = () => {
    const { currentUser } = useAuth();
    const { darkMode } = useDarkMode();
    const [archiveNames, setArchiveNames] = useState([]);
    // eslint-disable-next-line
    const [archiveData, setArchiveData] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [selectedDataFiltered, setSelectedDataFiltered] = useState(null);
    const [selectedArchive, setSelectedArchive] = useState(null); // State to track selected archive
    const [accountCreationDate, setAccountCreationDate] = useState(null);

    const [updating, setUpdating] = useState(false);
    
    const [alertsOn] = useState(() => {
        const storedSettings = localStorage.getItem('alertsOn');
        return storedSettings ? JSON.parse(storedSettings).alertsOn : false; // Default to false if null
    });
    
    const fetchAccountCreationDate = async () => {
        // Check if account creation date exists in localStorage
        const storedAccountCreationDate = localStorage.getItem(`accountCreationDate_${currentUser.uid}`);

        if (storedAccountCreationDate) {
            // Use the stored value if it exists
            setAccountCreationDate(storedAccountCreationDate);
        } else {
            // If not, fetch from Firebase
            try {
                const userDocRef = doc(db, `Users/${currentUser.uid}`);
                const userDoc = await getDoc(userDocRef);
                if (userDoc.exists()) {
                    const data = userDoc.data();
                    setAccountCreationDate(data.created);

                    // Save the account creation date to localStorage
                    localStorage.setItem(`accountCreationDate_${currentUser.uid}`, data.created);
                }
            } catch (error) {
                console.error("Error fetching account creation date:", error);
            }
        }
    };
    
    const onUpdate = async () => {
        // Products
        try {
            const userDocRef = doc(db, `Users/${currentUser.uid}`);
            const userDoc = await getDoc(userDocRef);
            if (userDoc.exists()) {
                const data = userDoc.data();
                setAccountCreationDate(data.created);
                console.log("Success");

                // Save the account creation date to localStorage
                localStorage.setItem(`accountCreationDate_${currentUser.uid}`, data.created);
            }
        } catch (error) {
            console.error("Error fetching account creation date:", error);
        }
    };

    const generateArchiveNames = () => {
        if (!accountCreationDate) return;
    
        const now = new Date();
        const currentYear = now.getFullYear();
        const currentQuarter = Math.floor(now.getMonth() / 3) + 1; // Get the current quarter
    
        const startDate = new Date(accountCreationDate);
        const archiveNamesArray = [];
    
        while (startDate < now) {
            const year = startDate.getFullYear();
            const quarter = Math.floor(startDate.getMonth() / 3) + 1;
    
            // Skip adding the current quarter
            if (!(year === currentYear && quarter === currentQuarter)) {
                const archiveName = `archive_Q${quarter}_${year}`;
                if (!archiveNamesArray.includes(archiveName)) {
                    archiveNamesArray.push(archiveName);
                }
            }
    
            // Move to the next quarter
            startDate.setMonth(startDate.getMonth() + 3);
        }
    
        setArchiveNames(archiveNamesArray);
    };
    
    async function fetchArchivedData(archiveName) {
        setUpdating(true);
        const startTime = Date.now();
        
        // const cachedData = localStorage.getItem(`archiveData_${archiveName}_${currentUser.uid}`);
        // if (cachedData) {
        //     const parsedData = JSON.parse(cachedData);
        //     setArchiveData(parsedData);
        //     setSelectedData(parsedData);
        //     setSelectedDataFiltered(parsedData);
        //     setSelectedArchive(archiveName); // Set selected archive name
        //     // alert(`Archive data loaded from local Storage`);
        //     setUpdating(false);
        //     return;
        // }

        try {
            const clientsCollectionRef = collection(db, `Customers/${currentUser.uid}/clients`);
            const clientsSnapshot = await getDocs(clientsCollectionRef);

            let allArchiveData = [];

            for (const clientDoc of clientsSnapshot.docs) {
                const clientId = clientDoc.id;
                const archiveCollectionRef = collection(db, `Customers/${currentUser.uid}/clients/${clientId}/${archiveName}`);
                const archiveSnapshot = await getDocs(archiveCollectionRef);

                archiveSnapshot.forEach((doc) => {
                    allArchiveData.push({
                        userId: currentUser.uid,    // Add user ID
                        clientId,  // Add client ID
                        archiveName,
                        ...doc.data(),
                        id: doc.id, // Add document ID
                    });
                });
            }

            // localStorage.setItem(`archiveData_${archiveName}_${currentUser.uid}`, JSON.stringify(allArchiveData));
            setArchiveData(allArchiveData);
            setSelectedData(allArchiveData);
            setSelectedDataFiltered(allArchiveData);
            setSelectedArchive(archiveName); // Set selected archive name after fetching
            
            // if (alertsOn) {
            //     alert(`Archive data saved to local Storage`);
            // }
            
        } catch (error) {
            console.error("Error fetching archived data:", error);
        }
        
        const endTime = Date.now();
        const timeElapsed = (endTime - startTime) /1000;
        setUpdating(false);
        
        if (alertsOn) {
            alert(`Orders Updated in ${timeElapsed} secs`);
        }
    }
    
    
    
    // async function fetchAllArchivedData(archiveName) {
    //     setUpdating(true);
    //     const startTime = Date.now();
    //
    //     const cachedData = localStorage.getItem(`allArchiveData_${archiveName}_${currentUser.uid}`);
    //     if (cachedData) {
    //         const parsedData = JSON.parse(cachedData);
    //         setArchiveData(parsedData);
    //         setSelectedData(parsedData);
    //         setSelectedDataFiltered(parsedData);
    //         setSelectedArchive(archiveName); // Set selected archive name
    //         // alert(`Archive data loaded from local Storage`);
    //         setUpdating(false);
    //         return;
    //     }
    //
    //     try {
    //         const clientsCollectionRef = collection(db, `Customers/${currentUser.uid}/clients`);
    //         const clientsSnapshot = await getDocs(clientsCollectionRef);
    //
    //         let allArchiveData = [];
    //
    //         for (const clientDoc of clientsSnapshot.docs) {
    //             const clientId = clientDoc.id;
    //             const archiveCollectionRef = collection(db, `Customers/${currentUser.uid}/clients/${clientId}/${archiveName}`);
    //             const archiveSnapshot = await getDocs(archiveCollectionRef);
    //
    //             archiveSnapshot.forEach((doc) => {
    //                 allArchiveData.push({
    //                     userId: currentUser.uid,    // Add user ID
    //                     clientId,  // Add client ID
    //                     archiveName,
    //                     ...doc.data(),
    //                     id: doc.id, // Add document ID
    //                 });
    //             });
    //         }
    //
    //         localStorage.setItem(`allArchiveData_${archiveName}_${currentUser.uid}`, JSON.stringify(allArchiveData));
    //         setArchiveData(allArchiveData);
    //         setSelectedData(allArchiveData);
    //         setSelectedDataFiltered(allArchiveData);
    //         setSelectedArchive(archiveName); // Set selected archive name after fetching
    //
    //         if (alertsOn) {
    //             alert(`Archive data saved to local Storage`);
    //         }
    //
    //     } catch (error) {
    //         console.error("Error fetching archived data:", error);
    //     }
    //
    //     const endTime = Date.now();
    //     const timeElapsed = (endTime - startTime) /1000;
    //     setUpdating(false);
    //
    //     if (alertsOn) {
    //         alert(`Orders Updated in ${timeElapsed} secs`);
    //     }
    // }

    useEffect(() => {
        if (currentUser) {
            fetchAccountCreationDate();
        }
        // eslint-disable-next-line
    }, [currentUser]);

    useEffect(() => {
        generateArchiveNames();
        // eslint-disable-next-line
    }, [accountCreationDate]);

    const handleButtonClick = (archiveName) => {
        fetchArchivedData(archiveName);
    };
    
    
    const formatArchiveName = (archiveName) => {
        const parts = archiveName.split('_'); // Split by '_'
        const quarter = parts[1]; // Extract the quarter (e.g., "Q1")
        const year = parts[2]; // Extract the year (e.g., "2025")
    
        // Return formatted string
        return `${quarter} ${year}`;
    };
    
    
    const [searchQuery, setSearchQuery] = useState('');

    const handleArchiveSearch = (query) => {
        setSearchQuery(query);
        const filtered = selectedData.filter((order) =>
            order.customerName.toLowerCase().includes(query.toLowerCase()) ||
            order.customerCode.toLowerCase().includes(query.toLowerCase()) ||
            order.orderERP.toString().includes(query.toLowerCase()) ||
            
            order.products.some((prod) => prod.productCode.toLowerCase().includes(query.toLowerCase())) ||
            order.products.some((prod) => prod.name.toLowerCase().includes(query.toLowerCase()))
        );
        setSelectedDataFiltered(filtered);
    }
    
    const filterOrdersByPrice = (price) => {
        if (!selectedData) {
            setSelectedDataFiltered([]); // Set an empty array if selectedData is null
            return;
        }
        
        const filtered = selectedData.filter(order => price === '' || order.priceType === price);
        setSelectedDataFiltered(filtered);
    };
    
    const [orderForm, setOrderForm] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    
    // Function to handle both accountView and selected customer
    const handleViewOrder = (order) => {
        setOrderForm(true);
        setSelectedOrder(order);
    };
    
    const calculateTotalGrandTotal = (orders) => {
        if (!selectedData) {
            return 0;
        }
        return orders.reduce((total, order) => {
            return total + (parseFloat(order.grandTotal) || 0); // Add 0 for undefined grandTotal
        }, 0);
    };


    const grandTotal = calculateTotalGrandTotal(selectedDataFiltered);
    
    
    
    
    
    
    
    
    
    
    
    
    
    
     const [collapse, setCollapse] = useState(false);
     
     const toggleCollapse = () =>{
        setCollapse(!collapse);
     }
    
    
    

    return (
        
        <>
            {orderForm ? (
                <NewOrder
                    order={selectedOrder}
                    isEditing={true}
                    close={() => setOrderForm(false)}
                />
            ) : (
                <div className={`flex h-[calc(100dvh-4rem)] w-full transition-all duration-500 ease-in-out`}>
                    
                    {updating && (
                        <Loading/>
                    )}
                    
                    
                    {/*Redesign*/}
                    <div className={`animate-fadeIn z-20 ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} w-full`}>
                
                        <main>
                            
                            {/*Header*/}
                            <header>
                                {/* Secondary navigation TimeLine*/}
                                <nav className={`flex items-center justify-between overflow-x-auto border-b ${darkMode ? 'border-neutral-700' : 'border-gray-300'} py-2`}>
                                    <div
                                        role="list"
                                        className="flex w-fit flex-none gap-x-4 px-4 text-sm/6 font-semibold text-gray-400 sm:px-6 lg:px-8"
                                    >
                                        
                                        {archiveNames.map((archiveName, index) => (
                                            <React.Fragment key={archiveName}>
                                                <Button
                                                    onClick={() => handleButtonClick(archiveName)}
                                                    className={`rounded items-center justify-center flex flex-col hover:scale-105`}
                                                >
                                                    
                                                    <div className={selectedArchive === archiveName ? 'text-green-600' : ''}>
                                                        {formatArchiveName(archiveName)}
                                                    </div>
                                                    
                                                    
                                                </Button>
                                                
                                                {/* Add a separator between buttons, but not after the last one */}
                                                {index < archiveNames.length - 1 && (
                                                    <div className={`w-3 h-0.5 mt-auto mb-auto rounded-full ${darkMode ? 'bg-neutral-700' : 'bg-gray-300'}`}/> // Example separator, you can style this as needed
                                                )}
                                            </React.Fragment>
                                        ))}
                                        
                                    </div>
                                    
                                    <Button
                                        onClick={toggleCollapse}
                                        className={`z-50 mx-4`}
                                    >
                                        <ChevronDownIcon className={`${collapse ? 'rotate-180' : ''} transition-all duration-1000 size-6 text-green-600`}/>
                                    </Button>
                                    
                                </nav>
                                
                                {/* Heading */}
                                <div className={`${collapse ? 'hidden' : ''} flex flex-col items-start justify-between gap-x-8 ${darkMode ? ' bg-gray-700/10' : 'bg-neutral-300/50'} px-4 py-2 sm:flex-row sm:items-center sm:px-6 lg:px-8`}>
                                    <div>
                                        <div className="flex items-center gap-x-3">
                                            
                                            <h1 className="flex gap-x-3 text-base/7">
                                                
                                                <ActionPillButton
                                                    color={"green"}
                                                    onClick={onUpdate}
                                                    icon={ArrowPathIcon}
                                                    label={"Sync"}
                                                />
                                                
                                                <span className="font-semibold">Archived Orders</span>
                                                <span className="text-gray-600">/</span>
                                                <span className="font-semibold">Please Select Quarter from Above</span>
                                            </h1>
                                        </div>
                                        <p className="mt-2 text-xs/6 text-gray-500">These are passed orders placed through your account. These orders are archived quarterly</p>
                                    </div>
                                    <div className={`space-x-3 flex`}>
                                        
                                        <div className="flex items-center hover:scale-105 gap-x-3 order-first rounded-lg bg-green-600/10 px-2 py-1 text-lg font-medium ring-1 ring-green-600/30 ring-inset sm:order-none">
                                            <span className={`text-green-600 font-bold text-sm`}>$</span>
                                            {numberWithCommas(grandTotal.toFixed(2))}
                                            <span className={`text-green-600 font-bold text-sm`}>USD</span>
                                        </div>
                                        
                                        <div className="hover:scale-105 gap-x-3 order-first flex items-center rounded-lg bg-green-600/10 px-2 py-1 text-lg font-medium ring-1 ring-green-600/30 ring-inset sm:order-none">
                                            {selectedDataFiltered?.length || 0}
                                            <span className={`text-green-600 font-bold text-sm`}>orders</span>
                                        </div>
                                        
                                    </div>
                                </div>
                                
                                
                            </header>
                            
                            {/* Activity list */}
                            <div className="border-t border-white/10 pt-3">
                                
                                
                                {/*Search bar row*/}
                                <div className={`px-2 mb-3 grid grid-cols-4 w-full h-fit items-center ${darkMode ? 'text-white' : 'text-black'}`}>
                                
                                    {/*Search Bar*/}
                                    <div className="col-span-3 flex items-center h-fit text-sm">
                                        
                                        <Button
                                            // onClick={() => {
                                            //     const newListView = !listView;
                                            //     setListView(newListView);
                                            //     localStorage.setItem('listViewPreference', JSON.stringify(newListView));
                                            //   }}
                                            className="w-fit rounded-full mr-1.5 size-8 flex items-center justify-center align-middle">
                                            {/*{listView ? <RectangleGroupIcon className="size-5"/> : <QueueListIcon className="size-5"/>}*/}
                                        </Button>
                                        
                                        {/*<div className="text-sm mb-1">Customer</div>*/}
                
                                        <div className={`border ${darkMode ? 'text-white bg-darkMainColor border-neutral-700' : 'text-black bg-white'} w-full rounded-md flex items-center justify-center hover:scale-y-105 drop-shadow shadow-gray-900`}>
                                            <OrderSearchInput
                                                status={"Arc"}
                                                searchQuery={searchQuery}
                                                setSearchQuery={setSearchQuery}
                                                onSearch={handleArchiveSearch}
                                                darkMode={darkMode}
                                            />
                                        </div>
                
                                    </div>
                
                                    {/*Industry*/}
                                    <div className="col-span-1 mr-1.5 ml-1.5 h-full text-sm">
                
                                        <div className="flex flex-col w-full mr-3 h-full">
                                            {/*<div className="text-sm mb-1">Industry</div>*/}
                
                                           <Select
                                                className={`border ${darkMode ? 'text-white bg-darkMainColor border-neutral-700' : 'text-black bg-white'} focus:outline-none h-full drop-shadow shadow-gray-900 py-1 px-4 rounded-md hover:scale-y-105`}
                                                onChange={(e) => filterOrdersByPrice(e.target.value)}
                                            >
                                                <option value="">Select Price Type...</option>
                                                <option value="AG">Agriculture</option>
                                                <option value="DIST1">Distributor NE/INTL</option>
                                                <option value="DIST2">Distributor SE/CAN</option>
                                                <option value="NE">Northeast</option>
                                                <option value="SE">Southeast</option>
                                            </Select>
                                            
                                            
                                        </div>
                
                                    </div>
                                    
                                    
                                    {/*Pricing Type*/}
                                    {/*<div className="hidden col-span-1 ml-2 h-full flex justify-end space-x-6 text-sm">*/}
                                    {/*    <div className={`flex items-center justify-center h-full`}>*/}
                                    {/*        <div className="flex items-center h-full text-sm font-semibold">Dates*/}
                                    {/*        </div>*/}
                                    {/*        <Button*/}
                                    {/*            className="rounded-full mt-auto mb-auto h-full w-8 items-center justify-center align-middle"*/}
                                    {/*            // onClick={toggleDateAscDesc}*/}
                                    {/*        >*/}
                                    {/*            /!*<ArrowDownIcon className={`${DateAscDesc ? '' : 'rotate-180'} transition-all duration-1000 h-4 stroke-2 text-borderColor hover:text-bgLightGreen hover:stroke-2 hover:animate-pulse hover:scale-110 m-auto`}/>*!/*/}
                                    {/*        </Button>*/}
                                    {/*    </div>*/}
                                    {/*    */}
                                    {/*    <div className={`flex items-center justify-center h-full`}>*/}
                                    {/*        <div className="flex items-center h-full text-sm font-semibold">Total*/}
                                    {/*        </div>*/}
                                    {/*        <Button*/}
                                    {/*            className="rounded-full mt-auto mb-auto h-full w-8 items-center justify-center align-middle"*/}
                                    {/*            // onClick={toggleAscDesc}*/}
                                    {/*        >*/}
                                    {/*            /!*<ArrowDownIcon className={`${AscDesc ? '' : 'rotate-180'} transition-all duration-1000 h-4 stroke-2 text-borderColor hover:text-bgLightGreen hover:stroke-2 hover:animate-pulse hover:scale-110 m-auto`}/>*!/*/}
                                    {/*        </Button>*/}
                                    {/*    </div>*/}
                                    {/*    */}
                                    
                                    {/*</div>*/}
                                
                                
                                </div>
                                
                                
                                {/*Orders MAP*/}
                                <div className={`overflow-y-auto  ${collapse ? 'h-[calc(100dvh-10rem)]' : 'h-[calc(100dvh-14.5rem)]'} border-t scrollbar-hide ${darkMode ? 'text-white bg-darkMainColor border-neutral-700' : 'text-black bg-white'} p-1 rounded-b-lg scrollbar-hide`}>
                                    
                                    <OrderSection
                                        orders={selectedDataFiltered || []}
                                        emptyTitle={"No Archived Orders"}
                                        emptyDescription={"No Archived Orders For Selected Time Period"}
                                        darkMode={darkMode}
                                        status={"A"}
                                        archived={true}
                                        handleViewOrder={handleViewOrder}
                                        listView={true}
                                    />
    
                                </div>
        
                                
                                
                            </div>
                            
                        </main>
                    
                    </div>
                    
                    
                    
                </div>
            )}
        </>
    );
};

export default Archive;
